import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';

import { GtmService } from '@app/core/services/analytics/gtm.service';
import { BannerService } from '@app/core/services/banner/banner.service';
import { OutletService } from '@app/core/services/outlet/outlet.service';
import { StorageService } from '@app/core/services/util/storage.service';

import { MobileShopByCategoryComponent } from '../mobile-shop-by-category/mobile-shop-by-category.component';
import { DesktopShopByCategoryComponent } from '../desktop-shop-by-category/desktop-shop-by-category.component';
import { BrandRatingComponent } from '@project_app/components/brand-rating/brand-rating.component';

import { FeatureToggleDirective } from '@app/shared/directives/feature-toggle.directive';
import { Membership, ProductCategory } from '@app/shared/models/api-response/catalog-api-response';
import { UtilityService } from '@app/core/services/util/utility.service';

@Component({
    selector: 'app-shop-by-category',
    standalone: true,
    imports: [
        DesktopShopByCategoryComponent,
        MobileShopByCategoryComponent,
        BrandRatingComponent,
        FeatureToggleDirective,
        NgClass
    ],
    templateUrl: './shop-by-category.component.html',
    styleUrls: ['./shop-by-category.component.scss']
})
export class ShopByCategoryComponent {
    @Input() isBrandRating: boolean;
    @Input() memberships: Membership[] = [];
    @Input() isMobile: boolean;
    @Input() showMenuFirst: boolean;

    constructor(
        private outletService: OutletService,
        private gtmService: GtmService,
        private storageService: StorageService,
        private bannerService: BannerService,
        private router: Router,
        private utilityService: UtilityService
    ) {}

    showMenuByCategory(category: ProductCategory, index: number) {
        const { id, brand_id, override_action, name, saleable, is_subscribable } = category;
        if (!saleable || is_subscribable) {
            return;
        }
        if (!this.outletService.isOutletSelected()) {
            this.utilityService.openLocationSearchBar();
            return;
        }

        this.storageService.set('category_id', String(id));
        this.storageService.set('brand_id', String(brand_id));
        this.gtmService.logEventTracking('home_page', 'category_tile_click', 'name: ' + name + ' ' + 'tile_index: ' + index);

        if (override_action) {
            this.bannerService.superSaverAction(category, 'category');
        } else {
            this.router.navigateByUrl('/menu');
        }
    }
}
